module.exports = __webpack_public_path__ + "img/new-persons.75b8fc14.svg";